"use client";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { AppShell, type NavKey } from "@/components/AppShell";

// Öğrenci kabuğu tek bir layout'ta (F5): kenar çubuğu, abonelik/eğitmen
// yoklamaları, iki toast watcher'ı ve Footer sayfadan sayfaya kurulu kalır.
// Eskiden her sayfa `<AppShell>` ile sarılıyor, her geçişte hepsi yeniden
// kuruluyor ve `PendingEvalWatcher` yoklamasını baştan başlatıyordu.
// URL'ler değişmedi: `(shell)` bir route group, yola girmez.
//
// Seçili menü öğesi yoldan türer; kabuk dışındaki sayfalar (seans, rapor,
// eğitmen alanı, giriş ekranları) bu layout'un altında değildir.
const ACTIVE_BY_PREFIX: readonly [string, NavKey][] = [
  ["/dashboard", "cases"],
  ["/progress", "progress"],
  ["/card", "progress"],
  ["/guide", "guide"],
  ["/pricing", "pricing"],
  ["/settings", "settings"],
];

function activeFor(pathname: string): NavKey {
  const hit = ACTIVE_BY_PREFIX.find(([prefix]) => pathname === prefix || pathname.startsWith(prefix + "/"));
  return hit ? hit[1] : "cases";
}

export default function ShellLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  return <AppShell active={activeFor(pathname)}>{children}</AppShell>;
}
